import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Integration } from './integration'
import type { GetGoogleTokenDto } from './dto/get-google-token.dto'

export class IntegrationRepository extends BaseRepository<Integration> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.schedulerApi + '/' + 'export', token, cache)
    }

    async getGoogleRefreshToken(dto: GetGoogleTokenDto) {
        const { json, statusCode, message } = await this.request.post(this.config.schedulerApi + '/export/google/?token=' + this.resolvedToken, dto)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getIntegrationCalendars(integrationId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.schedulerApi + '/export/' + integrationId + '/calendars/?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
